module.exports = __webpack_public_path__ + "img/buddy_whiskers-04.0bebbf82.svg";